module.exports = __webpack_public_path__ + "img/arbre_fleuri.e5e3bfe4.webp";